import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";

import { Button, Checkbox, Col, Input, Radio, Row } from "antd";
import moment from "moment";

import PaymentApi from "../../../apis/Payment.api";
import productApi from "../../../apis/Product.api";
import salesManageApi from "../../../apis/SalesManage.api";
import userApi from "../../../apis/User.api";
import { setLoading } from "../../../redux/store/common/commonDuck";
import ContentHeaderComponent from "../../layout/ContentHeaderComponent";

import FaqComponent from "./FaqComponent";
import ProductBuyer from "./OrderCreate/ProductBuyer";
import ProductOption from "./OrderCreate/ProductOption";
import ProductPrice from "./OrderCreate/ProductPrice";
import ProductSearch from "./OrderCreate/ProductSearch";

const OrderCreateComponent = () => {
  const IMP = window.IMP;
  const IMP_UID = process.env.REACT_APP_IMP_UID ?? "";
  const history = useHistory();
  const dispatch = useDispatch();
  const user = useSelector((state) => state.auth.user);
  const isLoading = useSelector((state) => state.common.loading);
  const setIsLoading = (value) => dispatch(setLoading(value));
  // const setIsSearchText = (value) => dispatch(setSearchText(value));

  const [searchOptions, setSearchOptions] = useState({
    product_name: "",
    product_brand_name: "",
  });
  const [selectedProductRowKeys, setSelectedProductRowKeys] = useState([]);
  const [selectedProductRows, setSelectedProductRows] = useState([]);
  const [orderType, setOrderType] = useState("created_at");
  const [orderBy, setOrderBy] = useState("desc");
  const [selectedOptionRowKeys, setSelectedOptionRowKeys] = useState([]);
  const [selectedOptionRows, setSelectedOptionRows] = useState([]);
  const [optionList, setOptionList] = useState({
    total: [],
    except: [],
  });
  const [orderDetailList, setOrderDetailList] = useState([]);
  const [orderInfo, setOrderInfo] = useState({
    total_price: 0,
    statistics_gender: 1,
    statistics_age: 4,
  });
  const [selectOptions, setSelectOptions] = useState({
    same_deposit_name: true,
    cash_receipt_type: 2,
    statistics_query_select: "Naver",
    delivery_price: 0,
  });

  const [searchKeyword, setSearchKeyword] = useState("");
  // const [faqAddShow, setFaqAddShow] = useState(false);

  const [error, setError] = useState("");

  const [paymentType, setPaymentType] = useState("vbank");

  // 할인율 적용
  const [discountRate, setDiscountRate] = useState(0);
  const [discountAmount, setDiscountAmount] = useState(0);

  const paymentTypeOption = [
    { label: "가상계좌", value: "vbank" },
    // {label: "무통장입금", value: "deposit"},
    // {label: "카드결제", value: "card"}
  ];
  const cashReceiptTypeItems = [
    { label: "미발행", value: 2 },
    { label: "소득공제용", value: 0 },
    { label: "지출증빙용", value: 1 },
  ];
  const genderItems = [
    { label: "남성", value: 1 },
    { label: "여성", value: 2 },
  ];
  const ageItems = [
    { label: "10대", value: 1 },
    { label: "20대", value: 2 },
    { label: "30대", value: 3 },
    { label: "40대", value: 4 },
    { label: "50대", value: 5 },
    { label: "60대", value: 6 },
    { label: "70대", value: 7 },
    { label: "기타", value: 99 },
  ];
  const queryItems = [
    { label: "Youtube", value: "Youtube" },
    { label: "Naver", value: "Naver" },
    { label: "기타", value: 0 },
  ];

  // console.log(selectedOptionRows);
  const optionRowSelection = {
    selectedRowKeys: selectedOptionRowKeys,
    onChange: (selectedRowKeys, selectedRows) => {
      let editRows = [];

      editRows = selectedRows.map((item) => ({
        ...item,
        option_id: item?.id,
        product_name:
          item?.product_name ?? selectedProductRows[0]?.product_name,
        product_brand_name:
          item?.product_brand_name ??
          selectedProductRows[0]?.product_brand_name,
        seller_id: item?.seller_id ?? selectedProductRows[0]?.product_seller_id,
        seller_name:
          item?.seller_name ?? selectedProductRows[0]?.product_seller_name,
        saving_point_type:
          item?.saving_point_type ?? selectedProductRows[0].saving_point_type,
        saving_point:
          item?.saving_point ?? selectedProductRows[0]?.saving_point,
      }));

      // console.log(selectedRowKeys, selectedOptionRowKeys,
      //     ...editRows, ...selectedRows);
      editRows = [...selectedOptionRows, ...editRows];

      const filteredList = editRows.reduce((prev, curr) => {
        const findData = prev.find((item) => item.id === curr.id);
        if (!findData) {
          return prev.concat([curr]);
        } else {
          return prev;
        }
      }, []);

      console.log(filteredList, editRows, selectedRows);

      setSelectedOptionRowKeys(selectedRowKeys);
      setSelectedOptionRows(filteredList);

      // console.log(selectedRowKeys, selectedRows);
      // if (selectedOptionRowKeys.includes(record.id)) {
      //     editRows = selectedOptionRows.filter((row) => row.id !== record.id)
      //     editRowKeys = selectedOptionRowKeys.filter((key) => key !== record.id)
      // } else {
      //     editRows = [...selectedOptionRows, record]
      //     editRowKeys = [...selectedOptionRowKeys, record.id]
      // }
      // editRows = editRows.map((item) => ({
      //     ...item,
      //     product_name: item?.product_name ?? selectedProductRows[0]?.product_name,
      //     product_brand_name: item?.product_brand_name ?? selectedProductRows[0]?.product_brand_name,
      //     seller_id: item?.seller_id ?? selectedProductRows[0]?.product_seller_id,
      // }))
      // setSelectedOptionRows(editRows);
      // setSelectedOptionRowKeys(editRowKeys);
    },
  };
  // console.log(selectedOptionRowKeys, selectedOptionRows);

  const [sellerList, setSellerList] = useState([]);

  /**
   * 주문 결제 상품 - 수량 변경
   */
  // const changeProductQuantity = (e, method, value, index) => {
  //     e.stopPropagation();
  //     let total = [...optionList.total];
  //     let price = value.price_2;
  //     if (total[index]) {
  //         let totalPrice = orderInfo.total_price;
  //         if (method === "plus") {
  //             total[index].quantity += 1
  //             totalPrice += price
  //         } else if (total[index].quantity > 1) {
  //             total[index].quantity -= 1
  //             totalPrice -= price
  //         }
  //         setOptionList({
  //             ...optionList,
  //             total: total
  //         })
  //         setOrderInfo({...orderInfo, total_price: totalPrice})
  //     }
  // }

  useEffect(() => {
    if (user && (user.id === 1 || user.id === 2)) {
      setSearchOptions({ ...searchOptions, product_name: "더블랙맥주효모" });
    }
    if (user) {
      getSellerList();
    }
  }, [user, orderType, orderBy]);

  useEffect(() => {
    readProductOptions();
  }, [selectedProductRowKeys]);

  useEffect(() => {
    if (
      Object.keys(optionList)?.length > 0 &&
      selectedOptionRows?.length === 1 &&
      optionList.total &&
      optionList?.total?.length > 0
    ) {
      if (optionList.total[0]?.id === selectedOptionRows[0]?.id) {
        if (optionList.total[0].quantity === 1) {
          setSelectOptions({
            ...selectOptions,
            // delivery_price: 3000,
            delivery_price: 0,
          });
        } else {
          setSelectOptions({
            ...selectOptions,
            delivery_price: 0,
          });
        }
      } else {
        setSelectOptions({
          ...selectOptions,
          delivery_price: 0,
        });
      }
    } else {
      setSelectOptions({
        ...selectOptions,
        delivery_price: 0,
      });
    }

    let currList = [...orderDetailList];
    for (let i = 0; i < currList?.length; i++) {
      for (let j = 0; j < optionList.total?.length; j++) {
        if (currList[i]?.option_id === optionList.total[j]?.id) {
          if (currList[i].quantity !== optionList.total[j].quantity) {
            currList[i].quantity = optionList.total[j].quantity;
          }
        }
      }
    }
    setOrderDetailList(currList);
  }, [optionList, selectedOptionRows]);

  // useEffect(() => {
  //     if (orderDetailList) {
  //         let priceList = [];
  //         for (let i = 0; i < orderDetailList?.length; i++) {
  //             priceList.push(orderDetailList[i].price_2 * orderDetailList[i].quantity);
  //         }
  //         // let totalPrice = priceList.reduce((a, b) => a + b, 0);
  //         // setOrderInfo({
  //         //     ...orderInfo,
  //         //     total_price: totalPrice,
  //         // });
  //     }
  // }, [orderDetailList]);

  /**
   * 판매자 리스트 가져오기
   * @returns {Promise<void>}
   */
  const getSellerList = async () => {
    setIsLoading(true);
    try {
      const param = {
        userId: user.id === 724 ? 1 : user.id,
      };
      const res = await productApi.readSellerList(param);
      if (res.code === 200) {
        setSellerList(res.result);
      } else {
        alert("정상적인 요청이 아닙니다.");
      }
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      setError(error);
      console.log("getSellerList read error", error);
    }
  };

  // const [totalPrice, setTotalPrice] = useState(0)
  // useEffect(() => {
  //     if (sellerList?.length) {
  //         let delivery_price = sellerList[0].delivery_price;
  //         let base = sellerList[0].delivery_price_baseline;
  //
  //         let origin_total = 0;
  //         for (let i = 0; i < selectedOptionRows?.length; i++) {
  //             let price = selectedOptionRows[i].price_2 ?? selectedOptionRows[i].price_1;
  //             // console.log(selectedOptionRows[i].quantity);
  //             origin_total += price;
  //             // * selectedOptionRows[i].quantity;
  //         }
  //         // if (origin_total < base && origin_total) {
  //         //     if (origin_total + delivery_price !== orderInfo.total_price) {
  //         //         setOrderInfo({
  //         //             ...orderInfo,
  //         //             total_price: origin_total + delivery_price,
  //         //             // delivery_price: delivery_price
  //         //         })
  //         //     }
  //         // }
  //         // if (!selectedOptionRows?.length && orderInfo.total_price !== 0) {
  //         //     setOrderInfo({
  //         //         ...orderInfo,
  //         //         total_price: 0
  //         //     })
  //         // }
  //     }
  // }, [sellerList, orderInfo, selectedOptionRows]);

  /**
   * 선택 상품 옵션 api 호출
   */
  const readProductOptions = async () => {
    setIsLoading(true);
    try {
      if (selectedProductRowKeys?.length !== 0) {
        let exceptOptionList = [];
        for (const orderDetail of orderDetailList) {
          if (
            orderDetail.product_id === selectedProductRowKeys[0] &&
            orderDetail.hasOwnProperty("option_id")
          ) {
            exceptOptionList.push(orderDetail.option_id);
          }
        }
        const param = {
          product_id: selectedProductRowKeys[0],
          exceptOptions: exceptOptionList.join(","),
        };
        const res = await productApi.readProductOptionList(param);
        if (res.code === 200) {
          let totalList = [];
          for (let i = 0; i < res.result.productItemOptionList?.length; i++) {
            totalList.push({
              ...res.result.productItemOptionList[i],
              quantity: 1,
            });
          }
          setOptionList({
            total: totalList,
            except: res.result.productItemExceptOptionList,
          });
        } else {
          alert(
            "선택된 상품에 관한 옵션 정보를 불러오는데 실패하였습니다. 다시 시도해주시거나 관리자에게 문의해주시길 바랍니다.",
          );
        }
      } else {
        setOptionList({
          total: [],
          except: [],
        });
      }
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      setError(error);
      console.log("readProductOptions read error", error);
      alert(error);
    }
  };

  /**
   * 주문 생성
   */
  // const createOrder = async () => {
  //     const valid = createOrderValidation()
  //     if (valid && window.confirm(`아래의 정보들로 주문을 생성합니다. 기입하신 정보가 맞는지 다시 한번 확인해주시길 바랍니다.\n
  //     ■ 주문정보
  //     □ 제품명 : ${orderDetailList[0].product_brand_name} ${orderDetailList[0].product_name} ${orderDetailList?.length > 1 ? `외 ${orderDetailList?.length - 1}건` : ""}
  //     □ 주문총액 : ${orderInfo?.delivery_price > 0 ?
  //         `(배송비 포함 ${orderInfo?.delivery_price?.toLocaleString()}원) ` + (orderInfo.total_price + orderInfo?.delivery_price).toLocaleString() :
  //         orderInfo.total_price.toLocaleString()}원\n
  //     ■ 배송정보
  //     □ 받으시는 분 : ${orderInfo.name}
  //     □ 휴대폰 : ${orderInfo.phone}
  //     □ 주소 : ${orderInfo.address} ${orderInfo.hasOwnProperty("address_detail") && orderInfo.address_detail !== null ? orderInfo.address_detail : ""}
  //     `)) {
  //         setIsLoading(true)
  //         try {
  //             const userParam = {
  //                 nickname: orderInfo.name,
  //                 provider: "guest",
  //                 password: moment().format("YYYYMMDD"),
  //                 gender: null,
  //                 phone: orderInfo.phone,
  //                 birthday: null,
  //                 age: null,
  //                 created_by: user.id
  //             }
  //             const userRes = await userApi.createGuestUser(userParam)
  //             console.log("createOrder create user", userRes)
  //             if (userRes.code === 200) {
  //                 const userId = userRes.result.user.id
  //                 let sendOrderDetailList = []
  //                 let totalPoint = 0
  //                 for (const orderDetail of orderDetailList) {
  //                     // 포인트 적립
  //                     let point = 0
  //                     if (orderDetail.saving_point !== null && orderDetail.saving_point !== 0) {
  //                         point = orderDetail.saving_point_type ? ((orderDetail.price_2 * orderDetail.saving_point) / 100).toFixed() * orderDetail.quantity
  //                             : orderDetail.saving_point * orderDetail.quantity;
  //                         totalPoint += point
  //                     }
  //                     const sendOrderDetail = {
  //                         order_detail_status: "ready",
  //                         product_id: orderDetail.product_id,
  //                         quantity: orderDetail.quantity,
  //                         price: orderDetail.price_2,
  //                         total_price: orderDetail.price_2 * orderDetail.quantity,
  //                         point: point,
  //                         total_point: point
  //                     }
  //                     if (orderDetail.hasOwnProperty("option_id")) {
  //                         sendOrderDetail["option_id"] = orderDetail.option_id
  //                     }
  //                     sendOrderDetailList.push(sendOrderDetail)
  //                 }
  //                 const orderParam = {
  //                     totalOrder: {
  //                         ...orderInfo,
  //                         total_price: orderInfo?.delivery_price > 0 ? orderInfo.total_price + orderInfo?.delivery_price : orderInfo.total_price,
  //                         order_status: "ready",
  //                         total_point: totalPoint,
  //                         is_manual: true,
  //                         is_deposit: true,
  //                         created_by: userId
  //                     },
  //                     orderDetailList: sendOrderDetailList
  //                 }
  //                 if (selectOptions.cash_receipt_type !== 2) {
  //                     orderParam.totalOrder["cash_receipt_type"] = selectOptions.cash_receipt_type
  //                 }
  //                 if (selectOptions.statistics_query_select !== 0) {
  //                     orderParam.totalOrder["statistics_query"] = selectOptions.statistics_query_select
  //                 }
  //                 console.log("orderParam === ", orderParam)
  //                 const orderRes = await salesManageApi.orderCreate(orderParam)
  //                 if (orderRes.code === 200) {
  //                     const orderId = orderRes.result
  //                     const paymentParam = {
  //                         merchant_uid: orderId
  //                     }
  //                     const paymentRes = await salesManageApi.paymentCreateForDeposit(paymentParam)
  //                     if (paymentRes.code === 200) {
  //                         setIsLoading(false)
  //                         alert(`해당 정보들로 주문 생성에 성공했습니다.\n생성된 주문 번호: ${orderId}`)
  //                         setIsSearchText("deposit_ready")
  //                         history.push(`/salesManage/search`)
  //                     } else {
  //                         throw paymentRes.msg
  //                     }
  //                 } else {
  //                     throw orderRes.msg
  //                 }
  //             } else {
  //                 throw userRes.msg
  //             }
  //             setIsLoading(false)
  //         } catch (error) {
  //             setIsLoading(false)
  //             setError(error)
  //             console.log('createOrder create error', error)
  //             alert(error)
  //         }
  //     }
  // }

  const handleChange = async (e) => {
    const { name, value } = e.target;
    if (name === "product_name" || name === "product_brand_name") {
      setSearchOptions({ ...searchOptions, [name]: value });
    } else if (name === "popular") {
      setSearchOptions({ ...searchOptions, product_name: value.product_name });
      setSelectedProductRows([]);
      setSelectedProductRowKeys([]);
      // setSelectedOptionRows([]);
      // setSelectedOptionRowKeys([]);
      setOrderDetailList([]);

      const res = await productApi.readProductListAll(
        0,
        "",
        value.product_name,
        "",
        orderType,
        orderBy,
        user.id === 724 ? 1 : user.id,
      );
      if (res.code === 200) {
        setIsLoading(true);
        // setProductList(res.result);
        setSelectedProductRows([res.result[0]]);
        setSelectedProductRowKeys([res.result[0].product_id]);
        setIsLoading(false);
      }
    } else if (name === "name") {
      if (selectOptions.same_deposit_name) {
        setOrderInfo({ ...orderInfo, [name]: value, deposit_name: value });
      } else {
        setOrderInfo({ ...orderInfo, [name]: value });
      }
    } else if (name === "phone") {
      let phone = value.trim();
      if (phone) {
        if (phone.includes("-")) {
          phone = phone.replaceAll("-", "");
        }
        const param = {
          phone: phone,
          userId: user.id === 724 ? 1 : user.id,
        };
        const res = await salesManageApi.getOrderOneByPhone(param);
        if (res.code === 200) {
          setOrderInfo({
            ...orderInfo,
            [name]: value,
            name: res.result.name,
            deposit_name: res.result.name,
            address: res.result.address,
            address_detail: res.result.address_detail,
            postal_code: res.result.postal_code ? res.result.postal_code : null,
          });
        } else {
          setOrderInfo({ ...orderInfo, [name]: value });
        }
      } else {
        setOrderInfo({ ...orderInfo, [name]: value });
      }
    } else if (name === "cash_receipt_type") {
      if (value === 2) {
        setOrderInfo({ ...orderInfo, cash_receipt_phone: null });
      }
      setSelectOptions({ ...selectOptions, [name]: value });
    } else if (name === "statistics_query_select") {
      if (value !== 0) {
        setOrderInfo({ ...orderInfo, statistics_query: null });
      }
      setSelectOptions({ ...selectOptions, [name]: value });
    } else if (name === "same_deposit_name") {
      if (e.target.checked) {
        setOrderInfo({ ...orderInfo, deposit_name: orderInfo.name });
      }
      setSelectOptions({ ...selectOptions, [name]: e.target.checked });
    } else if (name === "faq-search") {
      setSearchKeyword(value);
    } else {
      setOrderInfo({ ...orderInfo, [name]: value });
    }
  };

  /**
   * 상품 검색
   */
  const handleProductSearch = () => {
    setSelectedProductRows([]);
    setSelectedProductRowKeys([]);
    // readProductList();
  };

  /**
   * 검색 상품 목록 선택
   */
  const handleProductRowEvent = (record) => {
    return {
      onClick: (_) => {
        if (selectedProductRowKeys.includes(record.product_id)) {
          setSelectedProductRowKeys([]);
          setSelectedProductRows([]);
          // setSelectedProductRows([])
          // setSelectedProductRowKeys([])
          // setSelectedOptionRows([]);
          // setSelectedOptionRowKeys([]);
          setOrderDetailList([]);
        } else {
          setSelectedProductRowKeys([record.product_id]);
          setSelectedProductRows([record]);
        }
      },
    };
  };

  const tableOnChange = (pagination, filters, sorter, extra) => {
    if (sorter) {
      //sorting 이벤트가 이루어졌을때
      if (sorter.order) {
        if (sorter.order === "descend") {
          setOrderBy("desc");
        } else if (sorter.order === "ascend") {
          setOrderBy("asc");
        }
        setOrderType(sorter.field);
        //sorting 이벤트 데이터가 초기화 되었을 시 (order 값 초기화)
      } else {
        setOrderType("created_at");
        setOrderBy("desc");
      }
    }
  };

  /**
   * 상품 옵션 목록 선택
   */
  const handleOptionRowEvent = (record) => {
    return {
      onClick: (_) => {
        let editRows = [];
        let editRowKeys = [];
        if (selectedOptionRowKeys.includes(record.id)) {
          editRows = selectedOptionRows.filter((row) => row.id !== record.id);
          editRowKeys = selectedOptionRowKeys.filter(
            (key) => key !== record.id,
          );
        } else {
          editRows = [...selectedOptionRows, record];
          editRowKeys = [...selectedOptionRowKeys, record.id];
        }
        editRows = editRows.map((item) => ({
          ...item,
          option_id: item?.id,
          product_name:
            item?.product_name ?? selectedProductRows[0]?.product_name,
          product_brand_name:
            item?.product_brand_name ??
            selectedProductRows[0]?.product_brand_name,
          seller_id:
            item?.seller_id ?? selectedProductRows[0]?.product_seller_id,
          seller_name:
            item?.seller_name ?? selectedProductRows[0]?.product_seller_name,
          saving_point_type:
            item?.saving_point_type ?? selectedProductRows[0].saving_point_type,
          saving_point:
            item?.saving_point ?? selectedProductRows[0].saving_point,
        }));
        setSelectedOptionRows(editRows);
        setSelectedOptionRowKeys(editRowKeys);
        setOrderDetailList(editRows);

        // let detailList = [];
        // let totalPrice = orderInfo.total_price;
        // for (let i = 0; i < editRows?.length; i++) {
        //     let param = {
        //         product_brand_name: selectedProductRows[0].product_brand_name,
        //         product_name: selectedProductRows[0].product_name,
        //         product_id: selectedProductRowKeys[0],
        //         target_id: selectedProductRows[0].target_id,
        //         option_id: editRows[i].id,
        //         product_option_title: editRows[i].option_title,
        //         quantity: editRows[i].quantity,
        //         price_1: editRows[i].price_1,
        //         price_2: editRows[i].price_2,
        //         discount: editRows[i].discount,
        //         saving_point_type: selectedProductRows[0].saving_point_type,
        //         saving_point: selectedProductRows[0].saving_point
        //     }
        //     detailList.push(param);
        //     // totalPrice += editRows[i].price_2
        // }
        // setOrderDetailList(detailList);
        // setOrderInfo({...orderInfo, total_price: totalPrice});
      },
    };
  };

  /**
   * 상품-옵션 선택 완료
   */
  // const selectProductComplete = () => {
  //     let addSelectProductList = [...orderDetailList]
  //     console.log("addSelectProductList", selectedProductRows)
  //     let totalPrice = orderInfo.total_price
  //     if (optionList.total?.length === 0) {
  //         console.log("selectProductComplete no option ===== ", selectedProductRows[0])
  //         const orderDetail = {
  //             product_brand_name: selectedProductRows[0].product_brand_name,
  //             product_name: selectedProductRows[0].product_name,
  //             product_id: selectedProductRowKeys[0],
  //             target_id: selectedProductRows[0].target_id,
  //             quantity: 1,
  //             price_1: selectedProductRows[0].price_1,
  //             price_2: selectedProductRows[0].price_2,
  //             discount: selectedProductRows[0].discount,
  //             saving_point_type: selectedProductRows[0].saving_point_type,
  //             saving_point: selectedProductRows[0].saving_point
  //         }
  //         addSelectProductList.push(orderDetail)
  //         totalPrice += selectedProductRows[0].price_2
  //     } else {
  //         for (const option of selectedOptionRows) {
  //             const orderDetail = {
  //                 product_brand_name: selectedProductRows[0].product_brand_name,
  //                 product_name: selectedProductRows[0].product_name,
  //                 product_id: selectedProductRowKeys[0],
  //                 target_id: selectedProductRows[0].target_id,
  //                 option_id: option.id,
  //                 product_option_title: option.option_title,
  //                 quantity: 1,
  //                 price_1: option.price_1,
  //                 price_2: option.price_2,
  //                 discount: option.discount,
  //                 saving_point_type: selectedProductRows[0].saving_point_type,
  //                 saving_point: selectedProductRows[0].saving_point
  //             }
  //             addSelectProductList.push(orderDetail)
  //             totalPrice += option.price_2
  //         }
  //     }
  //     setOrderDetailList(addSelectProductList)
  //     setOrderInfo({...orderInfo, total_price: totalPrice})
  //     // setSelectedProductRows([])
  //     // setSelectedProductRowKeys([])
  //     // setSelectedOptionRows([])
  //     // setSelectedOptionRowKeys([])
  // }

  /**
   * 취소 버튼
   */
  const cancelBtnClick = () => {
    if (
      window.confirm(
        "해당 페이지에서 나가면 지금까지 작성했던 기록들이 전부 사라집니다.\n그래도 나가시겠습니까?",
      )
    ) {
      history.go(-1);
    }
  };

  /**
   * 주문 결제 상품 삭제
   */
  // const deleteProduct = (index) => {
  //     let currList = [...orderDetailList]
  //     const removed = currList.splice(index, 1)
  //     setOrderDetailList(currList)
  //     setOrderInfo({...orderInfo, total_price: orderInfo.total_price - (removed[0].price_2 * removed[0].quantity)})
  // }

  /**
   * 주문 결제 상품 선택 disabled
   */
  // const selectProductDisabled = () => {
  //     if (selectedProductRowKeys?.length === 0) {
  //         return true
  //     } else {
  //         if (optionList.total?.length === 0) {
  //             if (orderDetailList?.length === 0) {
  //                 return false
  //             } else {
  //                 const findIdx = orderDetailList.findIndex((orderDetail) => orderDetail.product_id === selectedProductRowKeys[0])
  //                 if (findIdx !== -1) {
  //                     return true
  //                 } else {
  //                     return false
  //                 }
  //             }
  //         } else {
  //             return selectedOptionRowKeys?.length === 0
  //         }
  //     }
  // }

  /**
   * 주문 생성 validation
   */
  const createOrderValidation = () => {
    if (orderDetailList?.length === 0) {
      alert("구매하시려는 상품이 선택되지 않았습니다.");
      return false;
    } else if (orderInfo.name === null || orderInfo.name === "") {
      alert("주문자 정보 > 받는 분의 성함이 입력되지 않았습니다.");
      return false;
    } else if (orderInfo.phone === null || orderInfo.phone === "") {
      alert("주문자 정보 > 핸드폰 번호가 입력되지 않았습니다.");
      return false;
    } else if (orderInfo.phone.includes("-")) {
      alert(
        "주문자 정보 > 핸드폰 번호 입력시 - 는 빼고 입력해주시길 바랍니다.",
      );
      return false;
    } else if (orderInfo.address === null || orderInfo.address === "") {
      alert("주문자 정보 > 배송지가 입력되지 않았습니다.");
      return false;
    } else if (
      orderInfo.deposit_name === null ||
      orderInfo.deposit_name === ""
    ) {
      alert("주문자 정보 > 입금자명이 입력되지 않았습니다.");
      return false;
    } else if (
      selectOptions.cash_receipt_type !== 2 &&
      (orderInfo.cash_receipt_phone === null ||
        orderInfo.cash_receipt_phone === "")
    ) {
      alert(
        "주문자 정보 > 현금영수증을 발행할 휴대폰번호가 입력되지 않았습니다.",
      );
      return false;
    } else if (
      selectOptions.cash_receipt_type !== 2 &&
      orderInfo.cash_receipt_phone.includes("-")
    ) {
      alert(
        "주문자 정보 > 현금영수증을 발행할 휴대폰번호 입력시 - 는 빼고 입력해주시길 바랍니다.",
      );
      return false;
    } else if (discountAmount > orderInfo.total_price) {
      alert("할인 금액이 주문 총액보다 큽니다.");
      return false;
    } else {
      return true;
    }
  };

  /**
   * 카드 결제
   */
  const handlePurchase = async (e) => {
    console.log(e);
    console.log(paymentType);
    IMP.init(IMP_UID);
    // console.log(valid, IMP_UID);
    if (paymentType !== "vbank") {
      IamPortBilling();
    } else {
      const valid = createOrderValidation();
      // IamPortVbank();
      if (
        valid &&
        window.confirm(`아래의 정보들로 주문을 생성합니다. 기입하신 정보가 맞는지 다시 한번 확인해주시길 바랍니다.\n
            ■ 주문정보
            □ 제품명 : ${selectedOptionRows[0].product_brand_name} ${
              selectedOptionRows[0].product_name
            } ${
              selectedOptionRows?.length > 1
                ? `외 ${selectedOptionRows?.length - 1}건`
                : ""
            }
            □ 주문총액 : ${
              orderInfo?.delivery_price > 0
                ? `(배송비 포함 ${orderInfo?.delivery_price?.toLocaleString()}원) ` +
                  (
                    orderInfo.total_price +
                    orderInfo?.delivery_price -
                    discountAmount
                  ).toLocaleString()
                : (orderInfo?.total_price - discountAmount)?.toLocaleString()
            }원\n
            ■ 배송정보
            □ 받으시는 분 : ${orderInfo?.name}
            □ 휴대폰 : ${orderInfo?.phone}
            □ 주소 : ${orderInfo?.address} ${
              orderInfo.hasOwnProperty("address_detail") &&
              orderInfo?.address_detail !== null
                ? orderInfo?.address_detail
                : ""
            }
            `)
      ) {
        if (paymentType === "vbank") {
          payByVbank();
        }
      }
    }
  };

  const IamPortVbank = (orderId) => {
    IMP.request_pay(
      {
        pg: "html5_inicis.MOI6671119", //테스트 시 html5_inicis.INIpayTest 기재
        pay_method: "vbank",
        merchant_uid: orderId, //상점에서 생성한 고유 주문번호
        name: `${selectedOptionRows[0].product_brand_name} ${
          selectedOptionRows[0].product_name
        } ${
          selectedOptionRows?.length > 1
            ? `외 ${selectedOptionRows?.length - 1}건`
            : ""
        }`,
        amount: `${
          orderInfo?.delivery_price > 0
            ? orderInfo.total_price + orderInfo?.delivery_price - discountAmount
            : orderInfo.total_price - discountAmount
        }`,
        buyer_email: "",
        buyer_name: `${orderInfo.name}`,
        buyer_tel: `${orderInfo.phone}`,
        buyer_addr: `${orderInfo.address} ${
          orderInfo.hasOwnProperty("address_detail") &&
          orderInfo.address_detail !== null
            ? orderInfo.address_detail
            : ""
        }`,
        buyer_postcode: `${orderInfo.postal_code}`,
        // m_redirect_url : '{모바일에서 결제 완료 후 리디렉션 될 URL}',
        // escrow: true, //에스크로 결제인 경우 설
        // bypass : {
        //     acceptmethod : "noeasypay" // 간편결제 버튼을 통합결제창에서 제외(PC)
        //     P_RESERVED: "noeasypay=Y"  // 간편결제 버튼을 통합결제창에서 제외(모바일)
        //     acceptmethod: 'cardpoint'  // 카드포인트 사용시 설정(PC)
        //     P_RESERVED : 'cp_yn=Y'     // 카드포인트 사용시 설정(모바일)
        // },
        // period: {
        //     from: "20200101", //YYYYMMDD
        //     to: "20201231"   //YYYYMMDD
        // }
      },
      function (rsp) {
        // callback 로직
        if (rsp.success) {
          alert("가상 계좌 생성 성공");
          console.log(rsp);
          history.push(`/salesManage/search`);
        } else {
          alert("가상 계좌 생성 실패");
        }
      },
    );
  };

  const payByVbank = async () => {
    const userParam = {
      nickname: orderInfo.name,
      provider: "guest",
      password: moment().format("YYYYMMDD"),
      gender: null,
      phone: orderInfo.phone,
      birthday: null,
      age: null,
      created_by: user.id === 724 ? 1 : user.id,
    };
    const userRes = await userApi.createGuestUser(userParam);
    console.log("createOrder create user", userParam, userRes);
    if (userRes.code === 200) {
      const userId = userRes.result.user.id;
      let sendOrderDetailList = [];
      let totalPoint = 0;

      // 할인 비율 계산
      const totalOriginalPrice = orderInfo.total_price;
      const discountRatio =
        totalOriginalPrice > 0 ? discountAmount / totalOriginalPrice : 0;

      // 선택한 옵션에서 detail 생성
      for (const orderDetail of selectedOptionRows) {
        // 포인트 적립
        let point = 0;
        if (
          orderDetail.saving_point !== null &&
          orderDetail.saving_point !== 0
        ) {
          point = orderDetail.saving_point_type
            ? ((orderDetail.price_2 * orderDetail.saving_point) / 100).toFixed()
            : orderDetail.saving_point;
          totalPoint += point * orderDetail.quantity;
        }

        // 각 상품별 할인 금액 계산 (10원 단위로 반올림)
        const productOriginalPrice = orderDetail.price_2 * orderDetail.quantity;
        const productDiscountAmount =
          Math.round((productOriginalPrice * discountRatio) / 10) * 10;

        const sendOrderDetail = {
          order_detail_status: "ready",
          product_id: orderDetail.product_id,
          quantity: orderDetail.quantity,
          price: orderDetail.price_2,
          total_price: productOriginalPrice - productDiscountAmount,
          point: point,
          total_point: point,
        };
        if (orderDetail.hasOwnProperty("option_id")) {
          sendOrderDetail["option_id"] = orderDetail.option_id;
        }
        if (productDiscountAmount > 0) {
          sendOrderDetail["coupon_id"] = "ADMIN"; // [전화주문] 관리자 전용 할인
          sendOrderDetail["coupon_discount_price"] = productDiscountAmount;
        }
        sendOrderDetailList.push(sendOrderDetail);
        // console.log(orderDetail, sendOrderDetail);
      }
      const orderParam = {
        totalOrder: {
          ...orderInfo,
          total_price:
            orderInfo?.delivery_price > 0
              ? orderInfo.total_price +
                orderInfo?.delivery_price -
                discountAmount
              : orderInfo.total_price - discountAmount,
          order_status: "ready",
          total_point: totalPoint,
          is_manual: true,
          created_by: userId,
        },
        orderDetailList: sendOrderDetailList,
      };

      if (selectOptions.cash_receipt_type !== 2) {
        orderParam.totalOrder["cash_receipt_type"] =
          selectOptions.cash_receipt_type;
      }
      if (selectOptions.statistics_query_select !== 0) {
        orderParam.totalOrder["statistics_query"] =
          selectOptions.statistics_query_select;
      }
      console.log("orderParam === ", orderParam);
      try {
        const orderRes = await salesManageApi.orderCreate(orderParam);
        console.log("orderRes === ", orderRes);
        if (orderRes.code === 200) {
          const orderId = orderRes.result;
          IamPortVbank(orderId);
        } else {
          console.error("orderRes error:", orderRes);
          alert(`주문 생성 실패: ${orderRes.msg || "알 수 없는 오류"}`);
        }
      } catch (error) {
        console.error("orderCreate error:", error);
        alert(`주문 생성 중 오류가 발생했습니다: ${error.message || error}`);
      }
    } else {
      throw userRes.msg;
    }
  };

  const IamPortBilling = async () => {
    // 비인증
    let param = {
      merchant_uid: "test123",
      card_number: "5272-8904-6108-5387",
      expiry: "2028-10",
      birth: "960425",
      pwd_2digit: "12",
      customer_uid: "gildong_0001_1234",
      name: "박상호",
      buyer_addr: "주소입니다",
      buyer_name: "박상호",
      buyer_postcode: "15555",
      buyer_email: "",
      buyer_tel: "01029635750",
      amount: 1000,
    };
    const res = await PaymentApi.postOneTimePay(param);
    console.log(res);
    if (res.code === 200) {
      console.log(res.result);
    }
  };

  return (
    <>
      <ContentHeaderComponent title="전화 주문" />
      <div className={`product-register-wrap order-component-wrap`}>
        {/* 주문정보 */}
        <div className={`order-component-body`}>
          <Row className="order-component-box">
            <div className={`order-component-title-div`}>
              <h2 className="order-component-title">주문정보</h2>
            </div>
            <div className={`order-component-info`}>
              {/* 주문 상품*/}
              <div className={`order-component-each`}>
                <h3 className={`order-each-title`}>
                  주문 상품
                  <span className="title-required">*</span>
                </h3>
                <Col className={`order-component-each-col`}>
                  {/* 상품 검색 */}
                  <ProductSearch
                    searchOptions={searchOptions}
                    handleChange={handleChange}
                    handleProductSearch={handleProductSearch}
                    handleProductRowEvent={handleProductRowEvent}
                    tableOnChange={tableOnChange}
                    orderType={orderType}
                    orderBy={orderBy}
                    orderInfo={orderInfo}
                    setOrderInfo={setOrderInfo}
                    selectedProductRows={selectedProductRows}
                    setSelectedProductRows={setSelectedProductRows}
                    selectedProductRowKeys={selectedProductRowKeys}
                    setSelectedProductRowKeys={setSelectedProductRowKeys}
                  />
                  {/* 많이 찾는 상품 */}
                  {/*{user && (user.id === 1 || user.id === 2) && (*/}
                  {user && user.id === 0 && (
                    <div className={`order-component-each-detail`}>
                      <h4 className={`order-each-detail-title`}>
                        많이 찾는 상품
                      </h4>
                      <Row
                        align="top"
                        justify={"space-between"}
                        style={{ rowGap: "3px" }}
                      >
                        <Col className={`popular-checkbox`}>
                          <Checkbox
                            className="order-create-select-deposit-name"
                            name="popular"
                            value={{
                              product_name: `더블랙맥주효모환`,
                              product_id: 21041,
                            }}
                            checked={
                              searchOptions.product_name ===
                                "더블랙맥주효모환" ||
                              selectedProductRowKeys.includes(21041)
                            }
                            onChange={handleChange}
                          >
                            [프로메드] 더블랙맥주효모환
                          </Checkbox>
                        </Col>
                        <Col className={`popular-checkbox`}>
                          <Checkbox
                            className="order-create-select-deposit-name"
                            name="popular"
                            value={{
                              product_name: `부스트업 아르기닌 6000`,
                              product_id: 21042,
                            }}
                            checked={
                              searchOptions.product_name ===
                                "부스트업 아르기닌 6000" ||
                              selectedProductRowKeys.includes(21042)
                            }
                            onChange={handleChange}
                          >
                            [프로메드] 부스트업 아르기닌 6000
                          </Checkbox>
                        </Col>
                        <Col className={`popular-checkbox`}>
                          <Checkbox
                            className="order-create-select-deposit-name"
                            name="popular"
                            value={{
                              product_name: `에너지솔루션`,
                              product_id: 21040,
                            }}
                            checked={
                              searchOptions.product_name === "에너지솔루션" ||
                              selectedProductRowKeys.includes(21040)
                            }
                            onChange={handleChange}
                          >
                            [프로메드] 에너지솔루션
                          </Checkbox>
                        </Col>
                      </Row>
                    </div>
                  )}
                  {/* 옵션 설정 */}
                  <ProductOption
                    optionRowSelection={optionRowSelection}
                    optionList={optionList}
                    handleOptionRowEvent={handleOptionRowEvent}
                    selectedProductRowKeys={selectedProductRowKeys}
                  />
                </Col>
              </div>

              {/* 배송비, 총 금액 */}
              <ProductPrice
                sellerList={sellerList}
                orderInfo={orderInfo}
                setOrderInfo={setOrderInfo}
                selectedOptionRows={selectedOptionRows}
                setSelectedOptionRows={setSelectedOptionRows}
                selectedOptionRowKeys={selectedOptionRowKeys}
                setSelectedOptionRowKeys={setSelectedOptionRowKeys}
                // 할인율 적용
                discountRate={discountRate}
                setDiscountRate={setDiscountRate}
                discountAmount={discountAmount}
                setDiscountAmount={setDiscountAmount}
              />

              {/* 주문자 정보 */}
              {/* 받는 분, 핸드폰 번호, 배송지, 배송 요청사항, 입금자명, 현금영수증*/}
              <ProductBuyer
                orderInfo={orderInfo}
                setOrderInfo={setOrderInfo}
                handleChange={handleChange}
                paymentTypeOption={paymentTypeOption}
                paymentType={paymentType}
                setPaymentType={setPaymentType}
                selectOptions={selectOptions}
                setSelectOptions={setSelectOptions}
                cashReceiptTypeItems={cashReceiptTypeItems}
              />

              {/* 통계 */}
              <div className={`order-component-each`}>
                <h3 className={`order-each-title`}>통계</h3>
                <Col className={`order-component-each-col`}>
                  {/* 성별 */}
                  <div className={`order-component-each-detail`}>
                    <h4 className={`order-each-detail-title`}>성별</h4>
                    <Radio.Group
                      className="order-create-select-cash-receipt-type"
                      options={genderItems}
                      name="statistics_gender"
                      value={orderInfo.statistics_gender}
                      onChange={handleChange}
                    />
                  </div>
                  {/* 연령대 */}
                  <div className={`order-component-each-detail`}>
                    <h4 className={`order-each-detail-title`}>연령대</h4>
                    <Radio.Group
                      className="order-create-select-cash-receipt-type"
                      options={ageItems}
                      name="statistics_age"
                      value={orderInfo.statistics_age}
                      onChange={handleChange}
                    />
                  </div>
                  {/* 유입경로 */}
                  <div className={`order-component-each-detail`}>
                    <h4 className={`order-each-detail-title`}>유입경로</h4>
                    <Col wrap={false}>
                      <Radio.Group
                        className="order-create-select-cash-receipt-type"
                        options={queryItems}
                        name="statistics_query_select"
                        value={selectOptions.statistics_query_select}
                        onChange={handleChange}
                      />
                      <Input
                        name="statistics_query"
                        value={orderInfo.statistics_query}
                        onChange={handleChange}
                        disabled={selectOptions.statistics_query_select !== 0}
                        style={{
                          width: "100%",
                          marginTop: "5px",
                        }}
                      />
                    </Col>
                  </div>
                </Col>
              </div>
              {/* 주문생성/취소 버튼 */}
              <div className={`order-component-each save-button-group`}>
                <Button
                  className="product-register-button save"
                  // onClick={createOrder}
                  onClick={handlePurchase}
                  loading={isLoading}
                >
                  {isLoading ? null : "주문생성"}
                </Button>
                <Button
                  className="product-register-button cancel"
                  onClick={cancelBtnClick}
                >
                  취소
                </Button>
              </div>
            </div>
          </Row>
        </div>

        {/* 상담 내용 & FAQ */}
        <div
          className={`order-component-body flexColumn`}
          style={{
            minWidth: "50%",
          }}
        >
          {/* 상담내용 */}
          <Row className="order-component-box">
            <div className={`order-component-title-div`}>
              <h2 className="order-component-title">
                {user && (user.id === 1 || user.id === 2) ? "상담내용" : "메모"}
              </h2>
            </div>
            <div className={`order-component-info`}>
              <div className={`order-component-each`}>
                <div className={`order-component-each-detail`}>
                  <Row
                    align="top"
                    justify={"space-between"}
                    style={{ rowGap: "8px" }}
                  >
                    <Input.TextArea
                      className="order-create-memo-wrap"
                      name="memo"
                      value={orderInfo.memo}
                      onChange={handleChange}
                      placeholder={
                        user &&
                        (user.id === 1 || user.id === 2 || user.id === 724)
                          ? `안녕하세요. 프로메드입니다. 무엇을 도와드릴까요?
1) 고객님이라고 지칭할 것
2) 고객보다 전화를 먼저 끊지 말 것
3) 전문적인 질문 시 모르는 것이 있다면 약사 확인 후 안내드린다고 안내하기
4) 주문수량에 대해 3+1, 7+4 등 혜택 안내하기
5) 연락처는 핸드폰 발신자표시를 통해 확인하기
6) 주문생성 후 고객에게 메시지 확인 요청하기
`
                          : "해당 주문에 관한 간단한 내용을 작성해보세요."
                      }
                      style={{
                        minHeight: "180px",
                        height: "100%",
                      }}
                    />
                  </Row>
                </div>
              </div>
            </div>
          </Row>

          {/* FAQ */}
          {user && (user.id === 1 || user.id === 2 || user.id === 724) && (
            <Row className="order-component-box">
              <div
                className={`order-component-title-div`}
                style={{
                  display: "flex",
                  gap: "8px",
                }}
              >
                {/*{faqAddShow && (*/}
                {/*    <FaqAddComponent setFaqAddShow={setFaqAddShow}/>*/}
                {/*)}*/}
                <h2
                  className="order-component-title"
                  style={{
                    position: "relative",
                  }}
                >
                  FAQ
                </h2>
                <div
                  style={{
                    width: "100%",
                    height: "100%",
                    display: "flex",
                    // justifyContent: "space-between",
                    justifyContent: "end",
                    alignItems: "center",
                  }}
                >
                  {/*<Button className={`faq-add-button`} onClick={() => setFaqAddShow(!faqAddShow)}>*/}
                  {/*    <img*/}
                  {/*        alt={"추가하기 버튼"}*/}
                  {/*        src={`${process.env.REACT_APP_HOST}/assets/images/salesManage/plus.png`}*/}
                  {/*    />*/}
                  {/*    추가하기*/}
                  {/*</Button>*/}
                  <Button
                    className={`faq-add-button`}
                    onClick={() => setSearchKeyword("")}
                  >
                    <img
                      alt={"추가하기 버튼"}
                      src={`${process.env.REACT_APP_HOST}/assets/images/salesManage/refresh.png`}
                    />
                    초기화
                  </Button>
                </div>
              </div>
              <div
                className={`order-component-info`}
                style={{
                  gap: "1rem",
                }}
              >
                {/* 키워드 검색 */}
                <div className={`order-component-each`}>
                  <div className={`order-component-each-detail`}>
                    <Row
                      style={{ width: "100%", justifyContent: "space-between" }}
                    >
                      <Input.Search
                        name="faq-search"
                        value={searchKeyword}
                        onChange={handleChange}
                        placeholder={`키워드 검색`}
                        loading={isLoading}
                      />
                    </Row>
                  </div>
                </div>
                <FaqComponent
                  type={"call"}
                  searchKeyword={searchKeyword}
                  setSearchKeyword={setSearchKeyword}
                />
              </div>
            </Row>
          )}
        </div>
      </div>
    </>
  );
};

export default OrderCreateComponent;
